<div class="labelContainer" *ngIf="!isPaleStyle">
    <span class="claroLabel_contentContainer" [ngStyle]="{'background-color':  colorScheme}">
        <mat-icon *ngIf="iconPath != ''" class="claroLabel_claroNotificationIcon" [ngStyle]="{'color': '#FFFFFF'}">{{iconPath}}</mat-icon>
        <span class="claroLabel_text" [ngStyle]="{'font-size':fontSize}">{{labelText}}</span>
    </span>
</div>
<div class="claroLabel_labelContainer" *ngIf="isPaleStyle">
    <span class="claroLabel_paleBg" [ngStyle]="{'background-color':  colorScheme}">ך
        <span class="claroLabel_contentContainerHidden">
            <mat-icon *ngIf="iconPath != ''" class="claroLabel_claroNotificationIcon" [ngClass]="{'hidden':true}" [ngStyle]="{'color': colorScheme}">{{iconPath}}</mat-icon>
            <span class="claroLabel_text" [ngClass]="{'hidden':true}" [ngStyle]="{'color':  colorScheme, 'font-size':fontSize}">{{labelText}}</span>
        </span> 
    </span> 
    <span class="claroLabel_contentContainer_2">
        <mat-icon *ngIf="iconPath != ''" class="claroLabel_claroNotificationIcon" [ngStyle]="{'color': colorScheme}">{{iconPath}}</mat-icon>
        <span class="claroLabel_text" [ngStyle]="{'font-size':fontSize}">{{labelText}}</span>
    </span>
</div>
